import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { ShieldOff } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500 text-sm">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export const Guard = ({ children, module, adminOnly }) => {
  const { user, can } = useAuth();
  const allowed = adminOnly ? user?.role === "admin" : !module || can(module);
  if (!allowed && module === "dashboard") {
    const first = LANDING.find(([m]) => can(m));
    if (first) return <Navigate to={first[1]} replace />;
  }
  return allowed ? children : <NoAccess />;
};

const LANDING = [["shipments", "/shipments"], ["stock", "/inventory"], ["purchasing", "/purchasing"],
  ["masters", "/master-data"], ["mappings", "/mappings"], ["reports", "/reports"]];

export const NoAccess = () => {
  const { t } = useLang();
  return (
    <div className="h-full flex flex-col items-center justify-center text-center text-slate-500 py-24" data-testid="no-access-message">
      <ShieldOff size={40} className="mb-3 text-slate-400" />
      <p className="text-lg font-semibold text-slate-700">{t("no_access")}</p>
      <p className="text-sm">{t("no_access_hint")}</p>
    </div>
  );
};
